import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { Subscription, combineLatest, map } from 'rxjs';

import { DiagnosticProfile } from '../../models/diagnostic-profile';
import { DiagnosticBufferService } from '../../services/diagnostic-buffer.service';
import { DiagnosticProfileService } from '../../services/diagnostic-profile.service';
import { ScreenshotService } from '../../services/screenshot.service';
import { DiagnosticBundleModalComponent } from '../diagnostic-bundle-modal/diagnostic-bundle-modal.component';

@Component({
  selector: 'app-diagnostic-trigger',
  templateUrl: './diagnostic-trigger.component.html',
  styleUrls: ['./diagnostic-trigger.component.scss'],
})
export class DiagnosticTriggerComponent implements OnInit, OnDestroy {
  profiles: DiagnosticProfile[] = [];
  /** False when the active profile is 'disabled' (eventTypes empty). */
  diagnosticsEnabled = true;
  capturing = false;
  private subs = new Subscription();

  constructor(
    private readonly profileService: DiagnosticProfileService,
    private readonly bufferService: DiagnosticBufferService,
    private readonly screenshotService: ScreenshotService,
    private readonly dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.subs.add(
      combineLatest([
        this.profileService.getAvailableProfiles(),
        this.bufferService.activeProfile$,
      ])
        .pipe(
          map(([profiles, active]) => ({
            profiles,
            enabled: active.eventTypes.length > 0,
          }))
        )
        .subscribe(({ profiles, enabled }) => {
          this.profiles = profiles;
          this.diagnosticsEnabled = enabled;
        })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  async openModal(): Promise<void> {
    if (
      this.profiles.length === 0 ||
      !this.diagnosticsEnabled ||
      this.capturing
    ) {
      return;
    }
    this.capturing = true;
    let screenshot: Blob | null = null;
    try {
      // Capture BEFORE opening the dialog — otherwise the modal would
      // cover the actual view the user wants to send.
      screenshot = await this.screenshotService.capture();
    } finally {
      this.capturing = false;
    }
    this.dialog.open(DiagnosticBundleModalComponent, {
      data: { screenshot },
      autoFocus: false,
      restoreFocus: true,
    });
  }
}
